import { render, staticRenderFns } from "./CittadinoTopHeader.vue?vue&type=template&id=0daccf26"
import script from "./CittadinoTopHeader.vue?vue&type=script&lang=js"
export * from "./CittadinoTopHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports